export default __webpack_public_path__ + "static/media/card3.2c23b0a2.png";